import React, { useState, useEffect, Fragment } from 'react';
import { BrowserRouter as Router, Switch, Route, Link, useHistory, Redirect, useLocation, useParams } from "react-router-dom";
import './index.scss';
import { useSelector } from "react-redux";
import { useConfirmCheckoutQuery } from '../../services/checkout';
import { useTranslation } from 'react-i18next'
import CircularProgress from '@mui/material/CircularProgress';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Tag } from "antd";
import { useFetchQuery } from '../../services/cart';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import formatPrice from '../../Components/formatPrice';
import Button from '@mui/joy/Button';
var moment = require('moment');

function CheckoutConfirm() {
  const { userId, userToken, userEmail, userName, countryCode, cartToken, languageCode, guestShippment, guestPayment, isPurchase } = useSelector((state) => state.auth);
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation()
  const { refetch } = useFetchQuery({ userId: userId, cartToken: cartToken, countryCode: countryCode }, { count: 1 }, { refetchOnMountOrArgChange: true })

  const tapId = new URLSearchParams(location.search).get('tap_id') || null
  const orderId = new URLSearchParams(location.search).get('order_id') || null
  const orderToken = new URLSearchParams(location.search).get('order_token') || null
  const userParams = { userId: userId, userToken: userToken, countryCode: countryCode }

  const { data: confirmdata, isLoading, isFetching, isSuccess } = useConfirmCheckoutQuery({
    order_id: orderId,
    order_token: orderToken,
    tid: tapId,
    ...userParams
  }, { count: 1 }, { refetchOnMountOrArgChange: true })
  const results = confirmdata?.results
  const shippingInfo = Array.isArray(results?.guest_shipping) ? results?.guest_shipping?.[0] : results?.guest_shipping
  useEffect(() => {
    const alreadyTracked = localStorage.getItem("trackingPToken");
    // const alreadyTracked = sessionStorage.getItem("trackingToken");
    if (
      isSuccess &&
      results?.id &&
      results?.order_items?.length &&
      alreadyTracked !== String(results?.id)
    ) {
      refetch();

      const ItemsData = results.order_items.map(item => ({
        item_id: item?.product_id,
        item_name: item?.title,
        price: Number(item?.price),
        quantity: Number(item?.quantity),
      }));

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'purchase',
        ecommerce: {
          transaction_id: results.id,
          currency: results.currency,
          value: Number(results.amount),
          shipping: Number(results.shipping_price),
          items: ItemsData
        },
        user_data: {
          email: shippingInfo.email,
          phone_number: shippingInfo.phone,
          first_name: shippingInfo.name
        }
      });

      localStorage.setItem("trackingPToken", String(results?.id));
    }
  }, [confirmdata, isSuccess, results?.id, results?.order_items, shippingInfo]);

  function getDeliverydays(data, created) {
    if (Number(data) > 0) {
      return moment(created).add(Number(data), 'days').format('ddd Do MMM YY')
    } else {
      return moment(created).add(10, 'days').format('dd dDo MMM YY')
    }
  }

  const groupData = results?.order_items?.reduce((acc, obj) => {
    const key = obj.estimated_delivery;
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(obj);
    return acc;
  }, {});

  const storIds = [1, 3, 18, 19, 20, 21, 22, 23, 25, 11, 12]
  function functionIdLink(id, pid, store_id) {
    if (storIds?.includes(Number(store_id))) {
      return pid
    } else {
      return id
    }
  }
  function productTitle(title) {
    return title?.replace(/[^A-Za-z0-9]/g, ' ')?.replace(/[^\w\s.,]/gi, ' ')?.replace(/ /g, '-')
  }

  function fetchLoadingAndFetching(loading, fetching) {
    if (loading) {
      return true
    } else if (fetching) {
      return true
    } else {
      return false
    }
  }

  function getitesmData(data) {
    return (
      <div className='sp-section'>
        <div className='sp-card'>
          <div className='pd20' style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '20px' }}>
            <div style={{ textAlign: 'center' }}>
              <CheckCircleIcon color='success' style={{ fontSize: '2.5rem', marginBottom: '10px', filter: 'hue-rotate(45deg)' }} />
              <div style={{ fontSize: '1.1rem', fontWeight: 500 }}>
                {/* Your order <strong>#{results?.order_number}</strong> has been placed successfully. <br />Thank you */}
                Order placed, thank you!
              </div>
              <div style={{ marginBottom: '15px', fontSize: '14px' }}>We'll email you a confirmation.</div>
            </div>
          </div>

          {userId && userToken &&
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '20px' }}>
              <Button
                style={{ fontWeight: 400 }}
                component={Link}
                to={`/account/orders`}
                variant='soft'
                size={'sm'}>
                View Details
              </Button>
            </div>
          }

          {!userId && !userToken &&
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '20px' }}>
              <div style={{ fontWeight: 500, fontSize: '1rem' }}>
                Order Details
              </div>
            </div>
          }

          <div className='pd20' style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', justifyContent: 'space-between', gap: '10px', borderTop: '1px solid #d5d9d9', paddingTop: '15px' }}>
            <div className='w100-m'>
              <div className='jc-sb-m' style={{ display: 'flex', gap: '5px', flexWrap: 'wrap', fontSize: '14px' }}>
                <div style={{ fontWeight: 500 }}>Order Number:</div>
                <div style={{ fontWeight: 400 }}>
                  {results?.order_number}
                </div>
              </div>

            </div>
            <div className='w100-m'>
              <div className='jc-sb-m' style={{ display: 'flex', gap: '5px', flexWrap: 'wrap', fontSize: '14px' }}>
                <div style={{ fontWeight: 500 }}>Status:</div>
                <div style={{ fontWeight: 400 }}>
                  {results?.status ?
                    <span style={{ color: 'green' }}>Placed</span> :
                    <span style={{ color: 'tomato' }}>Pending</span>
                  }
                </div>
              </div>
              {/* <div className='jc-sb-m' style={{ display: 'flex', gap: '5px', flexWrap: 'wrap', justifyContent: 'flex-end', fontSize: '14px' }}>
                <span style={{ fontWeight: 500 }}>Shipping Fee:</span>
                <span>
                  {results?.currency} {results?.shipping_price === 0 ? 'FREE' : `${results?.shipping_price}`}
                </span>
              </div>
              <div className='jc-sb-m' style={{ display: 'flex', gap: '5px', flexWrap: 'wrap', justifyContent: 'flex-end', fontSize: '14px' }}>
                <span style={{ fontWeight: 500 }}>Total:</span>
                <span>
                  {formatPrice(results?.amount, results?.currency, results?.shipping_price)}
                </span>
              </div> */}
            </div>
          </div>
          <div className='pd20' style={{ fontSize: '14px', display: 'flex', gap: '5px', flexWrap: 'wrap', borderTop: '1px solid #d5d9d9' }}>
            <span style={{ fontWeight: 600 }}>Shipping To:</span>
            <span style={{ fontWeight: 500 }}>{shippingInfo?.name}</span>
            <span>{shippingInfo?.address}, {shippingInfo?.street}, {shippingInfo?.city}, {shippingInfo?.country}</span>
          </div>
          {groupData && Object?.entries(groupData).map(([group, groupItems]) => (
            <div
              key={group}
              className='pd20'
              style={{
                border: 'none',
                borderRadius: '0px',
                background: 'rgb(240, 242, 242)',
                marginBottom: '0px'
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', paddingBottom: '10px' }}>
                <div style={{ fontSize: '14px', display: 'blobk' }}>
                  <div style={{ fontWeight: 600 }}>{getDeliverydays(group, results?.createdAt)}</div>
                  <div style={{ fontWeight: 400 }}>{t('Estimated Delivery Date')}</div>
                </div>
              </div>
              <div className='sp-item-section'>
                {groupItems?.map((items, index) =>
                  <div key={index}>
                    <div className='sp-item-card' style={{ alignItems: 'flex-start', gap: '10px' }}>
                      <Link
                        to={`/product/${items.store_id}/${functionIdLink(items?.product_id, items?.pid, items?.store_id)}/${productTitle(items.title)}`}>
                        <img style={{ padding: '0px', maxWidth: '105px', minWidth: '105px', minHeight: '105px', maxHeight: '105px' }} className='sp-item-img' src={items.image} />
                      </Link>
                      <div className='sp-item-title'>
                        <Link to={`/product/${items.store_id}/${functionIdLink(items?.product_id, items?.pid, items?.store_id)}/${productTitle(items.title)}`}>
                          <p style={{ margin: 0, fontSize: '14px' }}>{items.title?.replace(/[^\w\s.,/:']/gi, ' ')}</p>
                        </Link>
                        {/* <div style={{ fontSize: '0.85rem', fontWeight: 500 }}>
                          <span>{items.currency} {items.price}</span>
                        </div> */}
                        <div className='sp-item-content' style={{ padding: '5px 0px 0px 0px' }}>
                          <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                            <Tag className='badge badge-light' style={{ padding: '.4em .4em', textAlign: 'start' }}>
                              <span style={{ fontWeight: 500 }}>Condition:&nbsp;</span>
                              <span style={{ fontWeight: 400 }}>{items.conditions}</span>
                            </Tag>
                            <Tag className='badge badge-light' style={{ padding: '.4em .4em', textAlign: 'start' }}>
                              <span style={{ fontWeight: 500 }}>Qty.:&nbsp;</span>
                              <span style={{ fontWeight: 400 }}>{items.quantity}</span>
                            </Tag>
                          </div>
                        </div>
                        {items.current_variant &&
                          <div
                            style={{ padding: '5px 0px 0px 0px', display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                            {Object.entries(items.current_variant || []).map(([key, value], index) => (
                              <Tag className='badge badge-light' style={{ marginBottom: '5px', padding: '.4em .4em', textAlign: 'start' }} key={index}>
                                <span style={{ fontWeight: 500 }}>{key}:&nbsp;</span>
                                <span style={{ fontWeight: 400 }}>{value}</span>
                              </Tag>
                            ))}
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    )
  }

  return (
    <div className="Purchase-page-Success Account-page" style={{ marginTop: '10px' }}>
      <br />
      <div className="container purchase-container">
        <div className="row purchase-section">
          {fetchLoadingAndFetching(isLoading, isFetching) &&
            <div className="col-md-12 mp0">
              <div style={{ position: 'relative', display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '1.2rem', marginBottom: '10px' }}>
                    Processing please wait!
                  </div>
                  <CircularProgress style={{ width: '2rem', height: '2rem', color: '#fe7f4a' }} />
                </div>
              </div>
            </div>
          }
          {!fetchLoadingAndFetching(isLoading, isFetching) &&
            <div className="col-md-6 mp0">
              <div className="row" style={{ justifyContent: 'center', width: '100%' }}>
                <div className="col-md-12 mp0">
                  {results ?
                    <>
                      {getitesmData(results?.order_items)}
                    </> :
                    <div
                      style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexWrap: 'wrap', gap: '5px' }}>
                      <ErrorOutlineOutlinedIcon style={{ color: '#721c24', fontSize: '1.3rem' }} />
                      <div
                        className='alert alert-danger'
                        style={{ border: 'none', background: '#fff0', padding: 0, margin: 0 }}>
                        Something went wrong!
                      </div>
                      <Link className="text-hover-link" to={`/`}>continue shopping</Link>
                    </div>
                  }
                </div>
              </div>
            </div>
          }
        </div>
      </div >
      <br />
      <br />
    </div >
  );
}

export default CheckoutConfirm;
